import { BsHouses } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditListings = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsHouses',
				label: 'houses',
				component: BsHouses,
			}}
			defaultTheme="blue"
			widgetType="listings"
		/>
	);
};

export default EditListings;
